module.exports = __webpack_public_path__ + "img/window-min-dots.77a53c68.svg";